import React, { useState } from 'react';
import axiosConfig from "../Service/axiosConfig"
import { FormParser } from '../Components';
import Masters from "../Components/masters.json"
import { useNavigate } from 'react-router-dom';

const AddUser = ({ handleLoginEvent }) => {
  const Navigate = useNavigate();
  const [Data, setData] = useState({})
  const [Loading, setLoading] = useState(false)
  const [Error, setError] = useState(null);
  const OnSubmit = (content) => {
    setError(null);
    setLoading(true);
    console.log(content, 'Signup button clicked!');
    axiosConfig.defaults.headers['Content-Type'] = 'multipart/form-data';
    axiosConfig.post("/accounts/api/signup/", content).then(res => {
      // localStorage.setItem('token', res.data.token);
      // localStorage.setItem('profile_data', JSON.stringify(res.data.profile_data));
      Navigate(`/dashboard/users/${res?.data?.profile_data?.profile_id}/edit`)
      handleLoginEvent()
      setLoading(false);
    }).catch(error => {
      console.log(error)
      if (error.response) {
        setError(error.response.data);
      }
      setLoading(false);
    })
  };
  const handleInputChange = (e) => {
    e.preventDefault();
    const name = e.target.name
    const value = e.target.value
    console.log(name, value)
    setData({ ...Data, [name]: value })
  }
  const HandleFiles = (e) => {
    e.preventDefault()
    const file = e.target.files[0];
    const name = e.target.name;
    const value = file;
    console.log(name, value);
    setData({ ...Data, [name]: value })
  }
  return (
    <div className="container">
      <FormParser modelObject={Masters.Signup} formData={Data} formSubmit={OnSubmit} error={Error} buttonTitle="Submit" button="btn-block" submitInProgress={Loading} />
    </div>
  );
};

export { AddUser };
